// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const StarChatIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16.48 11a.52.52 0 00-.44-.35l-2.58-.2-1-2.18a.52.52 0 00-.9 0l-1 2.18-2.56.22a.52.52 0 00-.44.35.51.51 0 00.17.54l1.89 1.54L9 15.38a.54.54 0 00.18.52.57.57 0 00.31.1.5.5 0 00.24-.06L12 14.7l2.23 1.24a.5.5 0 00.73-.56l-.58-2.28 1.93-1.54a.51.51 0 00.17-.56z"/><path d="M2 24V6a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2H6zm4-6h14V6H4v14z"/></svg>'} />;

StarChatIcon.displayName = 'StarChatIcon';

export default StarChatIcon;
